import { createFileRoute } from '@tanstack/react-router';
import { AdminTopicResourcesView } from '@/components/admin/AdminTopicResourcesView';

export const Route = createFileRoute('/_authed/admin/topics/$topicId')({
  component: AdminTopicResourcesPage,
});

function AdminTopicResourcesPage() {
  const { topicId } = Route.useParams();
  return <AdminTopicResourcesView topicId={topicId} />;
}
